(() => {
  if (window.icafeCommerceReady) return;
  window.icafeCommerceReady = true;
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], () => {});
  }
  const caches = new WeakMap();
  const timers = new WeakMap();
  const publish = (name, data = {}) => {
    const shopify = window.Shopify;
    if (shopify?.designMode || !shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    try { Promise.resolve(shopify.analytics?.publish(`icafe:${name}`, data)).catch(() => {}); } catch {}
  };
  const getContext = () => {
    const total = document.querySelector('[data-icc-total]');
    if (!total) return null;
    const id = total.dataset.productId;
    const form = document.querySelector(`form[id^="product-form-"][id$="${id}"]`);
    const source = document.querySelector('script[data-icc-variants]');
    if (!form || !source) return null;
    let variants = caches.get(source);
    if (!variants) {
      try { variants = JSON.parse(source.textContent); caches.set(source, variants); } catch { return null; }
    }
    const variantId = String(form.elements.namedItem('id')?.value || '');
    const picker = document.querySelector(`hdt-variant-picker[form="${CSS.escape(form.getAttribute('id'))}"]`);
    const selected = picker ? [...picker.querySelectorAll('input[is-value]:checked,input[is-value][type=hidden]')].map(input=>input.value) : [];
    const variant = variants.find(item => selected.length === item.options.length && item.options.every((value,index)=>value===selected[index])) || variants.find(item => String(item.id) === variantId);
    const quantity = Math.max(1, Number(form.elements.namedItem('quantity')?.value) || 1);
    return { total, form, variant, quantity, id };
  };
  const sync = () => {
    const context = getContext();
    if (!context?.variant) return;
    const { total, form, variant, quantity } = context;
    const value = total.querySelector('[data-icc-total-value]');
    const money = new Intl.NumberFormat(total.dataset.locale || 'ar-EG', { style:'currency',currency:total.dataset.currency || 'EGP',maximumFractionDigits:2 }).format(variant.price * quantity / 100);
    if (value.textContent !== money) value.textContent = money;
    document.querySelectorAll('[data-icc-blend]').forEach(card => card.dataset.selected = String(variant.options.includes(card.dataset.iccBlend)));
    const sticky = document.querySelector('hdt-sticky-btn-atc');
    const stickyForm = sticky?.querySelector('form');
    if (stickyForm) {
      const input = stickyForm.elements.namedItem('quantity');
      if (input && Number(input.value) !== quantity) input.value = String(quantity);
    }
    const stickyButton = sticky?.querySelector('.hdt-sticky-atc__variant-price button[tag-select]');
    if (stickyButton) {
      stickyButton.setAttribute('aria-label', `${variant.title} · ${total.dataset.label}: ${money}`);
      const prices = stickyButton.querySelectorAll('span');
      if (prices.length > 1) prices[prices.length - 1].textContent = ` — ${money}`;
    }
    const stickyMoney = sticky?.querySelector('.hdt-sticky-atc__product-monney');
    if (stickyMoney) stickyMoney.textContent = money;
    form.dataset.iccVariant = String(variant.id);
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; sync(); });
  };
  const observe = () => {
    schedule();
    document.querySelectorAll('hdt-variant-picker').forEach(picker => {
      if (picker.dataset.iccObserved) return;
      picker.dataset.iccObserved = 'true';
      new MutationObserver(schedule).observe(picker, {attributes:true,attributeFilter:['selected-variant']});
    });
  };
  document.addEventListener('change', event => {
    if (event.target.matches('hdt-sticky-btn-atc input[name=quantity]')) {
      const mainQuantity = getContext()?.form.elements.namedItem('quantity');
      if (mainQuantity && mainQuantity.value !== event.target.value) {
        mainQuantity.value = event.target.value;
        mainQuantity.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
    if (event.target.matches('input[name=quantity],input[name=id],input[name^=option],hdt-variant-picker input,select[data-cross-variant]')) {
      schedule();
      if (event.target.matches('hdt-variant-picker input')) setTimeout(() => {
        const context = getContext();
        if (context?.variant) publish('variant_selected', {product_id:context.id,variant_id:String(context.variant.id)});
      }, 250);
    }
    const select = event.target.closest('[data-cross-variant]');
    if (select) {
      const option = select.selectedOptions[0];
      const card = select.closest('.ic-cross-card');
      const price = card.querySelector('[data-cross-price]');
      if (price) price.textContent = option.dataset.money;
      const button = card.querySelector('button[name=add]');
      if (button) button.disabled = option.disabled || option.dataset.available === 'false';
    }
  });
  document.addEventListener('input', event => { if(event.target.matches('input[name=quantity]')) schedule(); });
  for (const name of ['variant:change','variant:update','variant:selected','quantity-selector:update']) document.addEventListener(name, schedule);
  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('.hdt-quantity__button');
    if (quantityButton) {
      const sticky = quantityButton.closest('hdt-sticky-btn-atc');
      if (sticky) requestAnimationFrame(() => {
        const source = sticky.querySelector('input[name=quantity]');
        const target = getContext()?.form.elements.namedItem('quantity');
        if (source && target && source.value !== target.value) {
          target.value = source.value;
          target.dispatchEvent(new Event('change',{bubbles:true}));
        }
        schedule();
      });
      else schedule();
    }
    const finder = event.target.closest('[data-roast],[data-blend]');
    if (finder) publish('coffee_finder_changed', {choice:finder.dataset.roast || finder.dataset.blend});
    const filter = event.target.closest('[data-ic-filter],[data-ic-category-filter]');
    if (filter) {
      const track = filter.closest('[data-ic-panel]')?.querySelector('[data-ic-track]');
      track?.scrollTo({left:0,behavior:'auto'});
      publish('catalog_filtered', {category:filter.dataset.icCategoryFilter || filter.dataset.icFilter});
    }
    const cardLink = event.target.closest('.ic-card a,.ic-cross-card a');
    if (cardLink) publish('product_card_clicked', {path:new URL(cardLink.href).pathname});
    if (event.target.closest('hdt-sticky-btn-atc button[name=add]')) sync();
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    const button = form.querySelector('button[name=add]');
    if (!button) return;
    if (form.dataset.iccSubmitting === 'true') { event.preventDefault(); event.stopImmediatePropagation(); return; }
    form.dataset.iccSubmitting = 'true';
    button.setAttribute('aria-busy','true');
    clearTimeout(timers.get(form));
    timers.set(form,setTimeout(() => { form.dataset.iccSubmitting = 'false';button.removeAttribute('aria-busy'); },10000));
    publish('add_to_cart_requested', {variant_id:String(form.elements.namedItem('id')?.value || ''),quantity:Number(form.elements.namedItem('quantity')?.value || 1),placement:form.closest('hdt-sticky-btn-atc')?'sticky':form.closest('.ic-cross-card')?'recommendation':'product'});
  },true);
  const release = () => document.querySelectorAll('form[data-icc-submitting=true]').forEach(form => {
    clearTimeout(timers.get(form));form.dataset.iccSubmitting='false';form.querySelector('button[name=add]')?.removeAttribute('aria-busy');
  });
  document.addEventListener('cart:update', event => { release();if (!event.detail?.data?.didError) publish('cart_updated'); });
  document.addEventListener('cart:error', release);
  document.addEventListener('shopify:section:load', observe);
  addEventListener('pageshow', () => { release();observe(); });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',observe,{once:true});else observe();
})();
